<template>
  <layout :title-text="title">
    <div slot="content" class="organization-container">
      <div class="article" v-for="(item, index) in orgList" :key="index">
        <img :src="item.imgSrc" draggable="false"/>
        <div class="text-content">
          <h2>{{item.orgTitle}}</h2>
          <span>
            <a :href="item.orgUrl" target="_blank">{{item.orgText}}</a>
            <a v-if="item.orgSecondText" :href="item.orgSecondUrl" target="_blank">{{item.orgSecondText}}</a>
            <a v-if="item.orgThirdText" :href="item.orgThirdUrl" target="_blank">{{item.orgThirdText}}</a>
          </span>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@components/layout'
import iconGuidance from '../../assets/images/icon_guidance.png'
import iconHost from '../../assets/images/icon_host.png'
import iconAssisting from '../../assets/images/icon_assisting.png'
export default {
  components: {
    Layout
  },
  data () {
    return {
      title: '大赛组织',
      orgList: [
        {
          imgSrc: iconGuidance,
          orgTitle: '指导单位',
          orgText: '公安部网络安全保卫局'
        },
        {
          imgSrc: iconHost,
          orgUrl: 'https://www.ppsuc.edu.cn/',
          orgTitle: '主办单位',
          orgText: '中国人民公安大学、',
          orgSecondUrl: 'https://www.bit.edu.cn/',
          orgSecondText: '北京理工大学、',
          orgThirdText: '奇安信科技集团股份有限公司',
          orgThirdUrl: 'https://www.qianxin.com/'
        },
        {
          imgSrc: iconAssisting,
          orgUrl: 'http://www.integritytech.com.cn/',
          orgTitle: '比赛平台',
          orgText: '北京永信至诚科技股份有限公司'
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.organization-container {
  position: relative;
  margin: 0 auto;
  padding-left: 100px;
  width: 700px;
  height: 450px;
  display: flex;
  flex-wrap: wrap;
  .article {
    width: 100%;
    box-sizing: border-box;
    color: #fff;
    padding: 30px;
    img {
      width: 99px;
      height: 107px;
      float: left;
      display: block;
    }
    h2 {
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #D1A341;
      margin-bottom: 15px;
    }
    span {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #5891FA;
      a {
        cursor: pointer;
        color: #5891FA;
      }
    }
    .text-content {
      padding-left: 10px;
      float: left;
      text-align: left;
      height: 88px;
    }
    &:after{
        content: '';
        clear: both;
        display: block;
    }
  }
}
</style>
